
<div class="w-100">
    <c-column-header
        v-if="title"
        :label = "title"
        class  = "primary"
    />
    <div
        @dragover.prevent
        @drop.prevent
        class      = "upload-panel lm-border mt-1"
        :style     = "minImageHightStype"
        @drop      = "onDrop"
        @dragleave = "fileDragOut"
        @dragover  = "fileDragIn"
        :class     = "drag ? 'drop-allowed':''"
    >
        <div>
            <img
                v-if  = "image"
                :src  = "image"
                alt   = ""
                class = "upload-image"
            />
        </div>
    </div>
    <slot name="additional" />
</div>
